<template>
  <div class="home-banner">
    <!-- 模块头部组件 -->
    <div class="head" :style="isBorder ? '' : 'border:none'">
      <div class="head-left">
        <span class="iconfont" :class="icon" :style="'color:' + color"></span>
        <div>{{ title }}</div>
      </div>
      <div class="head-center">
        <div v-for="(item, i) in list" :key="i" @click="onClick(i)" :class="active == i ? 'is-active' : ''">{{ item
        }}</div>
      </div>
      <div class="more" @click="onMore">{{ isMore ? '更多>>' : '' }}</div>
    </div>
  </div>
</template>
<script>
import { ref } from 'vue'
export default {
  name: 'HomeHead',
  props: {
    // 是否有更多
    isMore: {
      type: Boolean,
      default: true
    },
    // icon图标（这里是阿里图标库的图标 内容是class类名）
    icon: {
      type: String,
      default: ''
    },
    // head标题
    title: {
      type: String,
      default: ''
    },
    // 中间筛选部分内容
    list: {
      type: Array,
      default: () => []
    },
    // icon图标颜色
    color: {
      type: String,
      default: ''
    },
    // 是否有底部border
    isBorder: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    // 默认选中的筛选
    const active = ref(0)
    // 点击筛选
    const onClick = (val) => {
      active.value = val
      emit('onScreen', val)
    }
    // 点击更多
    const onMore = () => {
      emit('more')
    }
    return {
      active,
      onClick,
      onMore
    }
  }
}
</script>
<style scoped lang="less">
.head {
  width: 100%;
  height: 5.125rem;
  background: #FFFFFF;
  box-sizing: border-box;
  border-width: 0px 0px 1px 0px;
  border-style: solid;
  border-color: #F5F5F5;
  display: flex;
  align-items: center;
  justify-content: center;
  // padding: 0 1.25rem;
  position: relative;

  .head-left {
    display: flex;
    position: absolute;
    top: 25%;
    left: 1.25rem;

    .iconfont {
      font-size: 1.8rem;
      color: #FA8734;
    }

    div {
      font-size: 1.75rem;
      color: #1A1A1A;
      margin-left: 0.625rem;
    }
  }

  .head-center {
    display: flex;
    align-items: center;
    height: 100%;

    div {
      width: 7.5rem;
      height: 100%;
      font-size: 1.5rem;
      color: #666666;
      margin-right: 2.5rem;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .is-active {
      color: #349BF9;
      border-bottom: 0.187rem solid #349BF9;
      height: 100%;
    }
  }

  .more {
    /* 更多>> */
    font-size: 1rem;
    color: #BFBFBF;
    cursor: pointer;
    position: absolute;
    top: 40%;
    right: 1.25rem;
  }
}
</style>
